<template>
    <!-- Page Content -->
    <div class="d-lg-flex half">
        <div class="bg order-1 order-md-2"></div>
        <div class="contents order-2 order-md-1">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-7 py-4">
                        <div class="text-center mb-4">
                            <a :href="$router.resolve({ name: 'home' }).href" class="navbar-brand logo mr-0">
                                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                            </a>
                        </div>
                        <h3>Mot de passe oublié?</h3>
                        <p class="text-sm text-muted mb-4">Veuillez renseigner votre adresse e-mail pour recevoir un lien de
                            réinitialisation du mot de passe.</p>
                        <form @submit.prevent="forgot_password">
                            <div class="form-group card-label h-100 mb-3">
                                <label class="bg-light">E-mail</label>
                                <input type="email" id="email" class="form-control" v-model="email" required />
                            </div>
                            <div class="text-right">
                                <a class="forgot-link" :href="$router.resolve({ name: 'login' }).href">Souvenez-vous de
                                    votre mot de passe?</a>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary btn-block btn-lg login-btn btn-rounded w-100" type="submit">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Envoyez Lien</label>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Page Content -->
</template>
<script>
import { api } from "@/store"; // Import axios from your store

export default {
    data() {
        return {
            email: "",
        };
    },
    methods: {
        async forgot_password() {
            let payload = { email: this.email };
            try {
                $('.submit-section button').attr('disabled', 'disabled')
                $('.submit-section button span').removeClass('d-none')
                const response = await api.post(`/auth/forgot-password`, payload, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }).then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: 'Email envoyé avec succès.',
                    })
                }).finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                });
            } catch (error) {
                console.error("Error: " + error)
            }
        },
    },
};
</script>
